import { Log } from '@lightningjs/sdk'
import { loadBrands } from './api/Api'

export const appSettings = {
  StorageSettings: 'GPSettings',
  StorageAuth: 'GPauth',
  app: null,
  brands: [],
  currentBrand: {},
  currentStation: {},
  currentPlaying: {},

  searchState: {
    searchTerm: null,
    isSearchData: false,
  },

  appMenuState: {
    index: 0,
  },

  initialize: async () => {
    Log.info('initializing...')
    return new Promise(resolve => {
      loadBrands()
        .then(resp => {
          appSettings.brands = resp.brands
          if (resp && resp.brands && resp.brands.length > 0) {
            appSettings.currentBrand = appSettings.brands[0]

            resolve()
          }
        })
        .catch(err => {
          Log.error('Error initializing :', err)
        })
    })
  },
}
